import { Injectable } from '@angular/core';
import {
  AnzBenefit,
  AnzHomePageService,
} from '@rd/wl/anz/services/anz-home-page.service';

@Injectable()
export class AnzBizHomePageService extends AnzHomePageService {
  get benefits(): AnzBenefit[] {
    return [
      {
        ariaLabel:
          'wl.anz.home_page.benefits.learn_more_airline_partners_arial_label',
        headingKey: 'wl.anz.home_page.airline_partners.heading',
        descriptionKey: 'wl.anz.home_page.airline_partners.description',
        imageUrl: this.urlUtilsService.imageUrl(
          '/images/airline-partner-icon.png',
        ),
        buttonKey: 'wl.anz.home_page.benefits.learn_more',
        buttonRedirectUrl: '/transfer',
      },
      {
        ariaLabel: 'wl.anz.home_page.benefits.learn_more_gift_card_arial_label',
        headingKey: 'wl.anz.home_page.gift_cards.heading',
        descriptionKey: 'wl.anz.home_page.gift_cards.description',
        imageUrl: this.urlUtilsService.imageUrl('/images/giftcard-icon.png'),
        buttonKey: 'wl.anz.home_page.benefits.learn_more',
        buttonRedirectUrl: '/gift_card',
      },
      {
        ariaLabel: 'wl.anz.home_page.benefits.learn_more_cashback_arial_label',
        headingKey: 'wl.anz.home_page.cashback.heading',
        descriptionKey: 'wl.anz.home_page.cashback.description',
        imageUrl: this.urlUtilsService.imageUrl('/images/cashback-icon.png'),
        buttonKey: 'wl.anz.home_page.benefits.learn_more',
        buttonRedirectUrl: '/redeem_cash',
      },
      {
        ariaLabel:
          'wl.anz.home_page.benefits.learn_more_merchandise_arial_label',
        headingKey: 'wl.anz.home_page.merchandise.heading',
        descriptionKey: 'wl.anz.home_page.merchandise.description',
        imageUrl: this.urlUtilsService.imageUrl('/icons/icon-merchandise.svg'),
        buttonKey: 'wl.anz.home_page.benefits.learn_more',
        buttonRedirectUrl: '/merchandise',
      },
      ...(this.isEverydaySpendEnabled
        ? [
            {
              ariaLabel: 'Everyday Rewards learn more',
              headingKey: 'Everyday Rewards',
              descriptionKey:
                'Redeem your ANZ Reward Points for Everyday Rewards points.',
              imageUrl: this.urlUtilsService.imageUrl(
                '/icons/icon-everyday-spend.svg',
              ),
              buttonKey: 'wl.anz.home_page.benefits.learn_more',
              buttonRedirectUrl: '/everyday_rewards/checkout',
            },
          ]
        : []),
    ];
  }
}
